import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Reducer } from 'react';
import { deepClone } from '../utils';

/** 待播放列表项 */
export interface AudioUrlQueueItem {
  base64: string;
  text: string;
  key: string;
}

/** 待处理文本项 */
export interface TextQueueItem {
  text: string;
  key: string;
  conversationId?: string | null;
  /** 音频数据 */
  base64?: string;
}

export interface TTSState {
  /** 全局语音控制 */
  globalTts: boolean;
  /** 队列 */
  textQueue: TextQueueItem[];
  /** 语音播放状态 */
  ttsStatus: 'play' | 'pause' | 'stop';
  /** 当前播放的id */
  ttsId: string | null;
}

const initialState: TTSState = {
  globalTts: false,
  textQueue: [],
  ttsStatus: 'stop',
  ttsId: null,
};

const ttsSlice = createSlice({
  name: 'tts',
  initialState: deepClone(initialState),
  reducers: {
    updateTextQueue: (
      state: TTSState,
      action: PayloadAction<{ index: number; data: TextQueueItem }>,
    ) => {
      state.textQueue[action.payload.index] = action.payload.data;
    },
    addTextQueue: (state: TTSState, action: PayloadAction<TextQueueItem>) => {
      state.textQueue.push(action.payload);
    },

    clearQueue: (state: TTSState) => {
      state.textQueue = [];
    },

    /**
     * 设置全局语音
     */
    setGlobalTts: (state: TTSState, action: PayloadAction<boolean>) => {
      state.globalTts = action.payload;
    },

    /**
     * 语音播放状态 play | pause | stop
     * @param status
     */
    setTtsStatus: (
      state: TTSState,
      action: PayloadAction<TTSState['ttsStatus']>,
    ) => {
      state.ttsStatus = action.payload;
    },

    /**
     * 设置当前播放的key
     */
    setTtsId: (state: TTSState, action: PayloadAction<TTSState['ttsId']>) => {
      state.ttsId = action.payload;
    },
    resetProcessStepState: () => initialState,
  },
});

export const {
  setGlobalTts,
  addTextQueue,
  updateTextQueue,
  clearQueue,
  setTtsId,
  setTtsStatus,
  resetProcessStepState,
} = ttsSlice.actions;
export default ttsSlice.reducer as unknown as Reducer<
  TTSState,
  typeof ttsSlice.actions
>;
